import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledDiv = styled.div<{ color: string }>`
  .status-icon {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: ${(props) => props.color};
    margin-right: 8px;
  }
  .status-text {
    color: ${(props) => props.color};
  }
  .status-reason {
    font-style: italic;
  }
`
const StyledLabelReason = styled.span`
  cursor: pointer;
  border-bottom: 1.6px dashed var(--color-red-107);
`

interface IProps {
  statusColor: 'red' | 'green' | 'blue' | 'yellow' | 'violet' | 'lime'
  title?: string
  reason?: any
}

export const StatusType = {
  UnActive: 'red',
  deActive: 'red',
  'de-active': 'red',
  Active: 'green',
  active: 'green',
  unKnown: 'yellow'
}

const StatusColor: any = {
  red: 'var(--color-red-107)',
  green: 'var(--color-primary-108)',
  yellow: 'var(--color-amber-104)',
  blue: 'var(--color-blue-108)',
  violet: 'var(--color-violet-primary)',
  lime: 'var(--color-lime-108)',
  cyan: 'var(--color-cyan-106)'
}

const Status = ({ statusColor, title, reason }: IProps) => {
  const { t } = useTranslation()
  const hasReason = !!reason
  return (
    <StyledDiv color={StatusColor[statusColor as any]}>
      <span className="status-icon" />
      {!hasReason && <span className="status-text">{t(title || '')}</span>}

      {hasReason && (
        <Tooltip title={reason}>
          <StyledLabelReason className="status-text">
            {t(title || '')}
          </StyledLabelReason>
        </Tooltip>
      )}
    </StyledDiv>
  )
}

export default Status
